"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFaqPageSchema = void 0;
const getFaqPageSchema = (items) => {
    const questions = items.map((question) => {
        return {
            '@type': 'Question',
            name: question.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: question.answer
            },
        };
    });
    return {
        mainEntity: [...questions],
    };
};
exports.getFaqPageSchema = getFaqPageSchema;
